import { RootContainer } from '../../../root_container';
import { RegularDeliveryAction } from '../../../actions/regular_delivery/regular_delivery_action';
import { RegularDeliveryJsEnv } from '../../../models/regular_delivery/regular_delivery_js_env';

export class RegularDeliveryContainer extends RootContainer<RegularDeliveryJsEnv> {
  constructor() {
    super();

    /// 定期配送サービスの「申し込み画面へ」ボタン押下イベントリスナー設定
    document.querySelectorAll('[data-regular_delivery_item_code]')?.forEach(function(button) {
      button.addEventListener('click', function(e) {
        const target = e.target as HTMLElement;
        const catalogItemCode = target.dataset.item_code ?? '';
        const regularDeliveryCatalogItemCode = target.dataset.regular_delivery_item_code ?? '';
        if (catalogItemCode && regularDeliveryCatalogItemCode) {
          RegularDeliveryAction.movePageToRegularDeliveryApply(catalogItemCode, regularDeliveryCatalogItemCode);
        }
      });
    });
  }
}
